import * as _ from 'underscore';
import { DropdownService } from '../interfaces';
import { TranslateService } from '@devinforius/i-essentials';
import { ServicesOnlyParent, ServicesPTreeSelect } from '../models/iCourrier/service';

export function returnOnlyParentServices(services: DropdownService[]): ServicesOnlyParent[] {
  const filteredServices = services.filter((service) => service.description);
  if (filteredServices?.length === 0) return [];
  return filteredServices
    .filter((service) => service.parentId === null)
    .map((service) => {
      return {
        value: service.id,
        id: service.id,
        key: service.id,
        label: service.description,
        name: service.description,
        selectable: true,
        children: [],
      };
    });
}

export function manageServicesSetAsTreeSelect(
  allServices: DropdownService[],
  translater: TranslateService,
  serviceIdsUserHasAccessTo?: number[]
): { servicesForSingleCheck: ServicesPTreeSelect[]; servicesForMultiCheck: ServicesPTreeSelect[] } {
  const filteredServices = allServices.filter((service) => service.description);

  if (filteredServices?.length === 0)
    return {
      servicesForSingleCheck: [],
      servicesForMultiCheck: [],
    };

  const listOfServices: ServicesPTreeSelect[] = filteredServices.map((service) => {
    return { ...service, children: [], key: service.id };
  });

  const responseOfRecursion = simpleRecursion(null, listOfServices, [], serviceIdsUserHasAccessTo);

  const dataForMultiCheck = [...responseOfRecursion];

  dataForMultiCheck.unshift({
    label: translater.translate('homeCourrier.inventory.selectAll/unselectAll'),
    name: '',
    key: 'inforiusCheckAllForServices',
    value: 'inforiusCheckAllForServices',
    selectable: true,
    children: [],
  });
  const dataToSendBack = {
    servicesForSingleCheck: responseOfRecursion,
    servicesForMultiCheck: dataForMultiCheck,
  };
  return dataToSendBack;
}

export function simpleRecursion(
  parentId: number,
  listOfServices: ServicesPTreeSelect[],
  finalArray: ServicesPTreeSelect[],
  serviceIdsUserHasAccessTo?: number[]
): ServicesPTreeSelect[] {
  const children = listOfServices.filter((service) => service.parentId === parentId);

  if (children.length === 0) {
    return [];
  }

  const array = [];

  children.forEach((service) => {
    if (serviceIdsUserHasAccessTo?.includes(service.id) || !serviceIdsUserHasAccessTo?.length) {
      service.available = true;
      service.selectable = true;
    } else {
      service.available = false;
      service.selectable = false;
    }
    const dataChildren = simpleRecursion(service.id, listOfServices, array, serviceIdsUserHasAccessTo);
    dataChildren?.length ? (service.children = dataChildren) : (service.children = []);
    if (serviceIdsUserHasAccessTo?.length) {
      // If we have a list of services that the user has access to, we need to check if one of the child is available to make the parent available (or check if the parent is already available).
      if (service.available || (service.children.length && service.children.some((child) => child.available))) {
        array.push(service);
        return array;
      }
      return array;
    } else {
      array.push(service);
      return array;
    }
  });

  finalArray = array;
  return finalArray;
}

export function manageServicesByRightsForTreeSelect(services: DropdownService[]) {
  const filteredServices = services.filter((service) => service.description);
  if (filteredServices?.length === 0) return [];
}

export function manageServicesToBeMerged(services: DropdownService[]): {
  label: string;
  value: number;
  id: number;
  parentId: number;
  name: string;
  key: string;
  selectable: boolean;
  children: [];
  description: string;
  email: string;
}[] {
  const filteredServices = services.filter((service) => service.description);
  if (filteredServices?.length === 0) return [];

  let listOfMergedServices = [];

  filteredServices.forEach((filteredService) => {
    const parentDescription = filteredService.parentId
      ? (filteredServices.find((service) => service.id === filteredService.parentId)?.description ?? '')
      : '';

    listOfMergedServices.push({
      label: parentDescription + filteredService.description,
      value: filteredService.id,
      parentId: filteredService.parentId,
      name: parentDescription + filteredService.description,
      key: filteredService.id,
      selectable: true,
      children: [],
      description: filteredService.description,
      email: filteredService.email,
      id: filteredService.id,
    });
  });
  listOfMergedServices = _.sortBy(listOfMergedServices, 'label');
  return listOfMergedServices;
}
